import PropTypes from "prop-types";
import classNames from "classnames";
import React, {useState} from 'react';
import ReactSelect from "react-select";
import {useDispatch, useSelector} from 'react-redux';
import IconButton from '../../common/IconButton';
import {Controller, useForm} from "react-hook-form";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import { Translate, selectLang } from '../../../app/store/reducers/main/mainReducer';
import {shipmentDeleteAsync} from "../../../app/store/reducers/shipment/shipmentReducer";
import {ShipmentDeleteStatuses} from "../../../enum/reasons/ShipmentDeleteReasonType";
import checkPermission from "../../../enum/Permission/CheckPermission";
import {PermissionEdiShipmentDelete, PermissionEdiShipmentReject} from "../../../enum/Permission/EdiPermission";
import toastPermission from "../../../enum/Permission/ToastPermission";

const ShipmentDelete = ({id, ...props}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const lang = useSelector(selectLang)
    const t = Translate

    const {register, handleSubmit, reset, formState: {errors}, control} = useForm({
        defaultValues: {
            reason: '',
            comment: ''
        }
    });

    const handleShow = () => {
        if(dispatch(checkPermission(PermissionEdiShipmentDelete))) setShow(true);
        else dispatch(toastPermission())
    }
    const handleClose = () => {
        setLoading(false);
        reset();
        setShow(false);
    };

    const deleteShipmentHandler = (formData) => {
        setLoading(true)

        shipmentDeleteAsync({
            id: id,
            reason: formData.reason,
            comment: formData.comment,
        })
            .then(() => handleClose())
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    };

    return (
        <>
            <IconButton
                onClick={handleShow}
                variant="falcon-danger"
                size="sm"
                icon="trash"
                transform="shrink-3"
                {...props}
            >
            </IconButton>
            <Modal size="md" show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit(deleteShipmentHandler)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t(lang, "edi.shipments.shipment.navigation.modal_delete.title")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{t(lang, "edi.common.modal.reason")}</Form.Label>
                            <Controller
                                name="reason"
                                control={control}
                                rules={{required: t(lang, "edi.common.forms.validations.is_required")}}
                                render={({field}) => (
                                    <ReactSelect
                                        isClearable
                                        classNamePrefix="react-select"
                                        getOptionValue={option => option.id}
                                        options={ShipmentDeleteStatuses}
                                        getOptionLabel={option => t(lang, option.name)}
                                        onChange={option => field.onChange(option?.id)}
                                        className={classNames({'is-invalid': !!errors?.reason?.message})}
                                        placeholder={t(lang, "edi.common.modal.decline_reason.placeholder")}
                                    />
                                )}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.reason?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mt-2">
                            <Form.Label>{t(lang, 'edi.common.label.comment')}</Form.Label>
                            <Form.Control
                                as="textarea" rows={3}
                                {...register('comment')}
                                placeholder={t(lang, 'edi.common.leave_comment')}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {
                            handleClose()
                        }}>{t(lang, "edi.shipments.shipment.navigation.modal_delete.button_close")}</Button>
                        <Button variant="danger" className="d-flex align-items-center" disabled={loading} type="submit">
                            {loading && <Spinner className="me-1" animation="border" role="status" size="sm"/>}
                            {t(lang, "edi.shipments.shipment.navigation.modal_delete.button_delete")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

ShipmentDelete.propTypes = {
    id: PropTypes.string,
};

ShipmentDelete.defaultProps = {
    id: '',
};


export default ShipmentDelete;
